export default {
  root: {
    class: [
      // Flex & Alignment
      "flex items-center justify-between flex-wrap",
      "gap-2",

      // Spacing
      "p-3",

      "z-50",

      // Color
      "bg-white dark:bg-surface-800 shadow-lg shadow-black",
    ],
  },
  start: {
    class: "flex items-center",
  },
  center: {
    class: "flex items-center",
  },
  end: {
    class: "flex items-center",
  },
};
